var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-data-table',{staticClass:"v-icon-fix custom-table-header",attrs:{"headers":_vm.headers1(),"items":_vm.tableData,"prev-icon":"mdi-menu-left","next-icon":"mdi-menu-right","pagination":_vm.pagination},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"headerCell",fn:function(ref){
var header = ref.header;
return [_c('span',{staticClass:"font-weight-light text-warning text--darken-3",domProps:{"textContent":_vm._s(header.text)}})]}},{key:"items",fn:function(ref){
var index = ref.index;
var item = ref.item;
return [_c('ExamTr',{attrs:{"item":item,"index":index},on:{"examRowClick":_vm.passEvent}})]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-219d0b0c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./VueSrc/Exams/exam_register_components/ExamTermsTable.vue
// module id = 838
// module chunks = 0